module.exports = __webpack_public_path__ + "img/2.399c5f0d.jpg";